export default __webpack_public_path__ + "static/media/item2.4271cb7b.png";